import Editor from 'wangeditor'
import { default as request , getStaticPath } from '@/util/request'
import 'wangeditor/release/wangEditor.min.css'
import './index.scss'

export default {
  name: 'Editor',
  props: {
    value: null,
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: 'html',
      validator: (val) => {
        return ['html', 'text'].includes(val)
      }
    },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },
    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: false
    },

    type:{
      type:[Number , String],
      default:0
    },
  },
  data(){
    return {
      loading:false
    }
  },
  computed: {
    editorId () {
      return `editor${this._uid}`
    }
  },
  watch:{
    value(nv , ov){
      if(nv !== ov){
        if(nv){
          this.setContent(nv)
        }else{
          this.clear()
        }
      }
    }
  },

  mounted () {
    let editor = new Editor(this.$el)
    let { type } = this
    editor.customConfig.onchange = (html) => {
      let text = this.editor.txt.text()
      if (this.cache) localStorage.editorCache = html
      this.$emit('input', this.valueType === 'html' ? html : text)
      this.$emit('change', html, text)
    }

    editor.customConfig.onchangeTimeout = this.changeInterval
    editor.customConfig.uploadImgMaxLength = 1

    editor.customConfig.customUploadImg = (files, insert) => {
      this.loading = true
      request.upload({
        type , file:files[0]
      }).then(resp => {
        if(resp.code){
          alert(resp.msg)
        }else{
          insert( getStaticPath(resp.data , true) )
        }
        this.loading = false
      })
    }

    editor.create( )

    // 如果本地有存储加载本地存储内容
    let html = localStorage.editorCache

    if (html) editor.txt.html(html)

    this.editor = editor
  },

  methods:{
    clear(){
      this.editor.txt.html('')
    },

    setContent(html){
      this.editor.txt.html(html)
    }
  },

  render(){
    return <div class={{'loading':this.loading}}></div>
  }
}